import { Phone, MessageCircle, MapPin } from "lucide-react";
import { CONTACT, waLink } from "@/lib/api";

export function Footer() {
  return (
    <footer id="footer" className="bg-primary text-primary-foreground px-5 pt-16 pb-32 scroll-mt-16">
      <div className="mx-auto max-w-6xl">
        <div className="inline-flex bg-white rounded-2xl p-3">
          <img src="/logo.png" alt="The Quisine — Cloud Kitchen & Caterers" className="h-20 w-auto object-contain" />
        </div>
        <p className="mt-4 max-w-sm text-sm text-primary-foreground/70">{CONTACT.full}</p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-md">
          <a data-testid="footer-call" href={`tel:${CONTACT.phone}`}
            className="flex items-center gap-3 rounded-2xl border border-primary-foreground/20 p-4">
            <Phone className="w-5 h-5 text-accent" />
            <span>
              <span className="block text-xs text-primary-foreground/60">Call us</span>
              <span className="font-medium">{CONTACT.phone}</span>
            </span>
          </a>
          <a data-testid="footer-whatsapp" href={waLink("Hi The Quisine!")} target="_blank" rel="noreferrer"
            className="flex items-center gap-3 rounded-2xl border border-primary-foreground/20 p-4">
            <MessageCircle className="w-5 h-5 text-accent" />
            <span>
              <span className="block text-xs text-primary-foreground/60">WhatsApp</span>
              <span className="font-medium">Chat now</span>
            </span>
          </a>
        </div>

        <div className="mt-6 flex items-center gap-2 text-sm text-primary-foreground/70">
          <MapPin className="w-4 h-4 text-accent" /> {CONTACT.location}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-foreground/15 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs text-primary-foreground/50">
          <span>© {new Date().getFullYear()} {CONTACT.brand}. All rights reserved.</span>
          <a href="/admin" data-testid="admin-link" className="hover:text-primary-foreground">Admin</a>
        </div>
      </div>
    </footer>
  );
}
